import React, { useEffect } from 'react';
import useWizardStep from '../../hooks/useWizardStep';
import AppointmentTypeSelection from '../../steps/AppointmentTypeSelection';
import PersonalDataInput from '../../steps/PersonalDataInput';
import StoreAndTimeslotSelection from '../../steps/StoreAndTimeslotSelection';
import Summary from '../../steps/Summary';
import { WizardStep } from '../../types/Wizard';
import SelfRating from '../../steps/SelfRating';
import useAppointmentTypes from '../../hooks/useAppointmentTypes';
import useSetAppointmentType from '../../hooks/useSetAppointmentType';
import useSetWizardStep from '../../hooks/useSetWizardStep';

export const steps: Record<string, WizardStep> = getSteps();

function getSteps() : Record<string, WizardStep> {
  const stepMax = (window as any).maxStep ?? 5

  switch(stepMax) {
    case 5:
    return {
      appointment: 1,
      selfRating: 2,
      storeAndTimeslot: 3,
      // eslint-disable-next-line sort-keys-fix/sort-keys-fix
      personalInfo: 4,
      summary: 5,
    }
    case 3:
      return {
        appointment: 1,
        storeAndTimeslot: 2,
        // eslint-disable-next-line sort-keys-fix/sort-keys-fix
        personalInfo: 3,
      }
    default:
      return {
        appointment: 1,
        storeAndTimeslot: 2,
        // eslint-disable-next-line sort-keys-fix/sort-keys-fix
        personalInfo: 3,
        summary: 4,
      }
  }}

export const stepsPairs = Object.entries(steps) as [string, WizardStep][];

const Wizard: React.FC = () => {
  const [appointmentTypes, isLoading] = useAppointmentTypes();
  const setAppointmentType = useSetAppointmentType();
  const setStep = useSetWizardStep();
  useEffect(() => {
    if (!isLoading) {
      const searchParams = new URLSearchParams(window.location.search);
      const searchParamName = 'appointmentType';
      if (searchParams.has(searchParamName)) {
        const urlAppointmentType = searchParams.get(searchParamName)?.toLowerCase();
        const stepMax = (window as any).maxStep ?? 5;

        appointmentTypes &&
          appointmentTypes
            .filter((f) => f.isEnabled)
            .map((t) => {
              if (t.id == urlAppointmentType) {
                setAppointmentType(t);
                if (stepMax != 5 && t.id != '35f42b66-7450-4df4-9226-63a49d9cde78') {
                  setStep((prev) => (prev + 2) as WizardStep);
                } else {
                  setStep((prev) => (prev + 1) as WizardStep);
                }
              }
            });
      }
    }
  }, [isLoading]);

  const step = useWizardStep();

  return (
    <>
      {step === steps.appointment && <AppointmentTypeSelection />}
      {step === steps.selfRating && <SelfRating />}
      {step === steps.storeAndTimeslot && <StoreAndTimeslotSelection />}
      {step === steps.personalInfo && <PersonalDataInput />}
      {step === steps.summary && <Summary />}
    </>
  );
};
Wizard.displayName = 'Wizard';

export default Wizard;
